/** Coupon codes from affiliate links (?coupon=) and course-detail apply. */

const PENDING_COUPON_KEY = 'maktech_pending_coupon_v1';
const APPLIED_COUPON_KEY = 'maktech_applied_coupon_v1';

function isBrowser(): boolean {
  return typeof window !== 'undefined' && typeof sessionStorage !== 'undefined';
}

function normalize(raw: string | null | undefined): string | null {
  const code = String(raw ?? '')
    .trim()
    .toUpperCase();
  if (!code || code.length > 32) return null;
  return code;
}

/** Prefill from URL — not yet validated. */
export function setPendingCoupon(raw: string): string | null {
  const code = normalize(raw);
  if (!code) return null;
  if (!isBrowser()) return code;
  sessionStorage.setItem(PENDING_COUPON_KEY, code);
  return code;
}

export function peekPendingCoupon(): string | null {
  if (!isBrowser()) return null;
  try {
    return sessionStorage.getItem(PENDING_COUPON_KEY);
  } catch {
    return null;
  }
}

export function clearPendingCoupon(): void {
  if (!isBrowser()) return;
  sessionStorage.removeItem(PENDING_COUPON_KEY);
}

/** Validated coupon ready for cart / checkout. */
export function setAppliedCoupon(raw: string): string | null {
  const code = normalize(raw);
  if (!code) return null;
  if (!isBrowser()) return code;
  sessionStorage.setItem(APPLIED_COUPON_KEY, code);
  sessionStorage.removeItem(PENDING_COUPON_KEY);
  return code;
}

export function getAppliedCoupon(): string | null {
  if (!isBrowser()) return null;
  try {
    return sessionStorage.getItem(APPLIED_COUPON_KEY);
  } catch {
    return null;
  }
}

export function clearAppliedCoupon(): void {
  if (!isBrowser()) return;
  sessionStorage.removeItem(APPLIED_COUPON_KEY);
}
